<div class="button-bar">
  <div class="landing-page">
    <div class="image">
      <a>
        <img [src]="tcEnergyImg" />
      </a>
    </div>
  </div>
</div>

<app-progress-spinner [enabled]="loadingGoTo" />

<div class="buttons">
  @if (!isMobile()) {
    <div class="auto-width">
      <button
        pButton
        class="action-item"
        (click)="closeAllTabs()"
        label="{{ 'COMMON.LABEL.BUTTONS.CLOSE_ALL_TABS' | translate }}"
      ></button>
    </div>
  }
</div>

<div>
  <div class="text">
    {{ 'COMMON.HOME_TEXT.LINE_1' | translate }}
  </div>
  <div class="text">
    {{ 'COMMON.HOME_TEXT.LINE_2' | translate }}
    <a
      href="https://forms.office.com/Pages/ResponsePage.aspx?id=bOPOsFwiSE-2C5IfREtWmIQ6kf7vq09Bn3Xp0TuvUwpUMzNKMkFMUVkwS01OOU9TOUlWSjBBOUI1ViQlQCN0PWcu"
    >
      CR LINC Feedback form</a
    >
  </div>
  <div class="text">
    {{ 'COMMON.HOME_TEXT.LINE_3' | translate }}
    <a href="mailto:crlinc@tcenergy.com">crlinc&#64;tcenergy.com</a>
  </div>
  <div class="text">
    {{ 'COMMON.HOME_TEXT.LINE_4' | translate }}
    <a href="mailto:crlinc_support_us@tcenergy.com"
      >crlinc_support_us&#64;tcenergy.com</a
    >
  </div>
  <div class="text">
    {{ 'COMMON.HOME_TEXT.LINE_5' | translate }}
    <br /><a
      href="https://transcanada.sharepoint.com/sites/cr-linc"
      target="_blank"
      >https://transcanada.sharepoint.com/sites/cr-linc</a
    >
  </div>
  @if (canViewManagerNote) {
    <div class="text">
      <a
        class="orange-underline"
        href="https://transcanada.sharepoint.com/:w:/r/sites/uscrm/_layouts/15/Doc.aspx?sourcedoc=%7B3E2A4984-55B8-43AC-B352-E891E50C3625%7D&file=Post%20Incident%20Questionnaire%20Procedure.doc&action=default&mobileredirect=true&DefaultItemOpen=1&isSPOFile=1&ovuser=b0cee36c-225c-4f48-b60b-921f444b5698%2Comari_dawson%40tcenergy.com&wdExp=TEAMS-TREATMENT&web=1&clickparams=eyJBcHBOYW1lIjoiVGVhbXMtRGVza3RvcCIsIkFwcFZlcnNpb24iOiI0OS8yNjA3MTYxNjAxNCJ9"
        target="_blank"
        >{{ 'COMMON.HOME_TEXT.LINE_6' | translate }}</a
      >
    </div>
  }
</div>
